import { render } from "./DetailOrder.vue?vue&type=template&id=f4e00736&scoped=true"
import script from "./DetailOrder.vue?vue&type=script&lang=js"
export * from "./DetailOrder.vue?vue&type=script&lang=js"

import "./DetailOrder.vue?vue&type=style&index=0&id=f4e00736&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4e00736"]])

export default __exports__